<template>
  <Modal
    class="cc-modal"
    width="600"
    footer-hide
    v-model="visibility"
    title="修改密码"
  >
    <div class="content" style="position: relative">
      <loading :loading="loading" style="z-index: 11"></loading>
      <div class="section">
        <div class="col">
          <div class="name">原密码：</div>
          <Input
            class="height45"
            type="password"
            v-model="form.oldPwd"
            placeholder="请输入原密码"
            style="width: 200px"
            clearable
          />
        </div>
        <div class="col">
          <div class="name">新密码：</div>
          <Input
            class="height45"
            v-model="form.newPwd"
            type="password"
            placeholder="请输入新密码"
            style="width: 200px"
            clearable
          />
        </div>
        <div class="col">
          <div class="name">再次输入新密码：</div>
          <Input
            class="height45"
            v-model="form.confirmPwd"
            type="password"
            placeholder="再次输入新密码"
            style="width: 200px"
            clearable
          />
        </div>
      </div>
    </div>
    <div class="foot">
      <Button
        :loading="loading"
        @click="onConfirm"
        type="primary"
        style="margin-right: 20px"
        >确定</Button
      >
      <Button @click="onCancel">取消</Button>
    </div>
  </Modal>
</template>
<script>
import { userPwdUpdate } from "api/customer.js";
import { mapMutations } from "vuex";
import { getEncrypt } from "utils/encrypt";
import loading from "components/loading.vue";
export default {
  name: "updatePasswordModal",
  components: {
    loading,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        oldPwd: "",
        newPwd: "",
        confirmPwd: "",
      },
      loading: false,
    };
  },
  computed: {
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  methods: {
    ...mapMutations(["MUT_TOKEN_INFO"]),
    onCancel() {
      this.form = this.$options.data().form;
      this.visibility = false;
    },
    async onConfirm() {
      if (!this.form.oldPwd) {
        this.$Message.warning("请输入原密码！");
        return;
      }
      if (!this.form.newPwd) {
        this.$Message.warning("请输入新密码！");
        return;
      }
      if (!this.form.confirmPwd) {
        this.$Message.warning("请输入确认密码！");
        return;
      }
      if (this.form.newPwd !== this.form.confirmPwd) {
        this.$Message.warning("两次新密码输入不一致！");
        return;
      }
      this.loading = true;
      let newPwd = getEncrypt(this.form.newPwd);
      try {
        const params = {
          ymm: getEncrypt(this.form.oldPwd),
          xmm: newPwd,
          qrmm: newPwd,
        };
        const res = await userPwdUpdate(params);
        this.loading = false;
        if (res.code === 200 && res.result) {
          this.$emit("submit-success", (res) => {
            if (res) {
              this.onCancel();
              this.$Message.success("修改成功,请重新登录！");
              this.MUT_TOKEN_INFO({});
              window.location.reload();
              localStorage.removeItem("vuex");
            }
          });
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.cc-modal {
  .content {
    height: auto;
    min-height: 100px;
    max-height: 500px;
    overflow: auto;
  }
  .foot {
    border-top: 1px solid #dcdee2;
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
.col {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 20px;
  .name {
    color: #333333;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .label {
    color: #999999;
  }
}
.upload-section {
  width: 200px;
  height: 122px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .icon {
    width: 45px;
    height: 35px;
  }
}
.icon2 {
  border: 1px dashed #dcdee2;
  position: relative;
  width: 200px;
  height: 122px;
  background-size: cover;
  background-position: center;
  .close {
    position: absolute;
    right: 5px;
    top: 5px;
    cursor: pointer;
  }
}
</style>

<style lang="less" scoped>
/deep/.height45 {
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
</style>
